import React from 'react';

import { pageContext } from 'context'
import { 
    HomeModule, 
    SettingsModule, 
    SandboxModule, 
    CalendarModule, 
    InboxModule, 
    IntegrationsModule 
} from 'modules'

const ModuleScreen = props => {
    const {
        type,
        section
    } = props
    let module = type
    let updatedSection = section
    if(type.toUpperCase().includes(pageContext.MODULES.SETTINGS)){
        module = type && type.split('-')[0]
        updatedSection = section ? section : type && type.split('-')[1] && type.split('-')[1].toLowerCase()
    }

    switch(module){
        case pageContext.MODULES.HOME:
            return (<HomeModule/>)
        case pageContext.MODULES.SETTINGS:
            return (<SettingsModule section={updatedSection}/>)
        case pageContext.MODULES.CALENDAR:
            return (<CalendarModule/>)
        case pageContext.MODULES.INBOX:
            return (<InboxModule/>)
        case pageContext.MODULES.INTEGRATIONS:
            return (<IntegrationsModule/>)
        case pageContext.MODULES.SANDBOX:
            return (<SandboxModule/>)
        default:
            return (<div>Module not found</div>)
    }
}

export default ModuleScreen